import { GridColDef } from "@mui/x-data-grid";
import { Box, lighten, Stack, Typography } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import moment from "moment/moment";

import { Fields, TRow } from "./types";
import { BG_COLORS, STATUS_COLORS } from "../../../constants";
import { formatCurrency } from "../../../helpers";
import { PaymentStatuses } from "../../../features/billingHistory/billingHistory.types";

const planCol: GridColDef<TRow, TRow[Fields.PLAN]> = {
  field: Fields.PLAN,
  headerName: "Plan",
  flex: 2,
  minWidth: 250,
  renderCell: ({ value }) => {
    return (
      <Box display="flex" alignItems="center" height="100%">
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            width: 24,
            height: 24,
            borderRadius: 1,
            backgroundColor: lighten(BG_COLORS.primary, 0.9),
          }}
        >
          <InsertDriveFileIcon
            sx={{ color: BG_COLORS.primary }}
            fontSize="small"
          />
        </Stack>
        <Box ml={1.5}>
          <Typography fontSize={12} fontWeight={500} textTransform="capitalize">
            {value?.name.split("_")[0]}
          </Typography>
          <Typography fontSize={10} fontWeight={500} color="grey">
            {value?.invoiceNumber}
          </Typography>
        </Box>
      </Box>
    );
  },
};

const amountCol: GridColDef<TRow, TRow[Fields.AMOUNT], string> = {
  field: Fields.AMOUNT,
  headerName: "Amount",
  flex: 1,
  minWidth: 100,
  valueFormatter: ({ amount, currency }: TRow[Fields.AMOUNT]) =>
    formatCurrency(amount, undefined, {
      currency,
    }),
};

const statusCol: GridColDef<TRow, TRow[Fields.STATUS]> = {
  field: Fields.STATUS,
  headerName: "Status",
  flex: 1,
  minWidth: 100,
  renderCell: ({ value }) => {
    const backgroundColor: Record<PaymentStatuses, string> = {
      [PaymentStatuses.PAID]: STATUS_COLORS.success,
    };
    return (
      <Stack flexDirection="row" alignItems="center" gap={0.8} height="100%">
        <Box
          width={8}
          height={8}
          borderRadius="100%"
          sx={{ backgroundColor: value ? backgroundColor[value] : undefined }}
        />
        <Typography fontSize={13} fontWeight={500} textTransform="capitalize">
          {value?.split("_").join(" ")}
        </Typography>
      </Stack>
    );
  },
};

const dateCol: GridColDef<TRow, TRow[Fields.DATE], string> = {
  field: Fields.DATE,
  headerName: "Date",
  flex: 1,
  minWidth: 130,
  resizable: false,
  valueFormatter: (value: TRow[Fields.DATE]) =>
    moment(value).format("MMM DD, YYYY"),
};

export const billingHistoryColumns = [planCol, amountCol, statusCol, dateCol];
